import React from 'react'
import './Your_spritual.css'
import Common_Title_1 from '../../common/common_components/common_title_1/Common_Title_1'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import Guest_house_booking_modal from '../../common/modals/guest-house-booking-modal/Guest_house_booking_modal';
import Your_spritual_sec_card from './your_spritual_sec_card/Your_spritual_sec_card';

const Your_spritual = () => {
   
    return (
        <>
            <section className='Your_spritual_sec'>
                <div className='container'>
                    <Common_Title_1 subText={'Your Spiritual Stay Awaits'} />


                    <Your_spritual_sec_card  />
                </div>
            </section >

          
        </>
    )
}

export default Your_spritual
